import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center">
      <h1 className="text-6xl font-bold text-amber-500 mb-4">404</h1>
      <p className="text-2xl text-gray-700 mb-6">The page you are looking for does not exist.</p>
      <button
        onClick={handleGoHome}
        className="px-6 py-2 bg-amber-500 text-white rounded-md shadow hover:bg-amber-600 transition-all"
      >
        Go to Home Page
      </button>
    </div>
  );
};

export default NotFoundPage;
